import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-20 md:py-32 px-6 max-w-3xl mx-auto text-center" data-id="element-40">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="flex flex-col items-center" data-id="element-41">
        <div className="inline-block px-4 py-1.5 rounded-full bg-gray-100 text-sm font-bold tracking-wide text-gray-800 mb-8 uppercase" data-id="element-42">
          PRECIO DE LANZAMIENTO BETA
        </div>

        <div className="flex items-center justify-center gap-4 mb-4" data-id="element-43">
          <span className="text-3xl text-gray-400 line-through font-medium" data-id="element-44">
            $19.00
          </span>
          <span className="text-6xl md:text-7xl font-black text-black tracking-tight" data-id="element-45">
            $6.39
          </span>
        </div>

        <p className="text-gray-500 mb-12 font-medium" data-id="element-46">
          Precio final tras el testeo: $19.00
        </p>

        <motion.a href="https://claridaddiaria.com/cart/43064451596354:1" target="_blank" rel="noopener noreferrer" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="w-full md:w-auto flex items-center justify-center gap-3 bg-black text-white px-8 py-5 rounded-2xl text-lg md:text-xl font-bold shadow-xl hover:shadow-2xl transition-all duration-300 group" data-id="element-47">
          QUIERO ACCESO A LOS SOCIAL CHEAT CODES ($6.39)
          <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-48" />
        </motion.a>

        <p className="text-sm text-gray-500 mt-6 font-medium" data-id="element-49">
          Descarga instantánea en PDF.
        </p>
      </motion.div>
    </section>;
}